import * as THREE from 'three';

import { GLTFGroup } from '../lib/GLTFGroup';

import { BlackWhiteMaterial } from './materials/BlackWhiteMaterial';
import { WhiteBlackMaterial } from './materials/WhiteBlackMaterial';

/**
 * Balls animations
 */
export class BallsGLTF extends GLTFGroup {
    private ballMaterial: THREE.MeshStandardMaterial;

    static get animationOffset() {
        return -5;
    }

    static get whiteBlack() {
        return 'whiteBlack';
    }

    static get blackWhite() {
        return 'blackWhite';
    }

    constructor(viewer, gltf, textureName, textureType, color) {
        super(viewer, gltf, textureName);

        const params = {
            map: viewer.getTexture(textureName),
            roughness: 100,
            metalness: 0,
            side: THREE.FrontSide,
            envMap: viewer.getEnvMap(),
            envMapIntensity: viewer.getEnvMapIntensity(),
        };

        switch (textureType) {
            case BallsGLTF.whiteBlack:
                this.ballMaterial = new WhiteBlackMaterial(viewer, textureName, color, params);
                break;
            case BallsGLTF.blackWhite:
                this.ballMaterial = new BlackWhiteMaterial(viewer, textureName, color, params);
                break;
            default:
                this.ballMaterial = new THREE.MeshStandardMaterial({
                    color: 0xff0000,
                });
        }
    }

    sceneUpdate(scene) {
        scene.position.copy(this.viewer.scene.getObjectByName('MachinePosition').position);
    }

    meshUpdate(model) {
        model.material = this.ballMaterial;
        model.receiveShadow = false;
        model.castShadow = false;
    }

    animationUpdate(animation) {
        const action = this.mixer.clipAction(animation);
        action.startAt(BallsGLTF.animationOffset);
        action.play();
    }

    getScene() {
        return this.gltf.scene;
    }
}
